import $ from 'jquery'
import {Core} from "../../../assets/src/scripts/core.js";

export class ProductFeatures {

  constructor($container) {
    if (Core.isAdmin()) return

    this.$container = $container
    this.$window = $(window)

    this.$container.on('click', '.product-features-btn', this.handleClickBtnLearnMore.bind(this))
  }

  handleClickBtnLearnMore(e) {
    e.preventDefault()
    Core.scrollTo(this.$container.find('.product-features-body'), 600)
  }
}
